const systemRepository = (fetch: CustomFetch) => ({
  async getDateTime() {
    return await fetch<{ now: string }>('/v1/datetime')
  },
})

export default systemRepository
